// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IActivityDetailNotificationDto
 */
export interface IActivityDetailNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof IActivityDetailNotificationDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof IActivityDetailNotificationDto
     * @deprecated
     */
    approval_code?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IActivityDetailNotificationDto
     */
    approval_codes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof IActivityDetailNotificationDto
     */
    invoice_posting_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IActivityDetailNotificationDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IActivityDetailNotificationDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof IActivityDetailNotificationDto
     */
    custom_denial_reason?: string;
}

/**
 * Check if a given object implements the IActivityDetailNotificationDto interface.
 */
export function instanceOfIActivityDetailNotificationDto(value: object): value is IActivityDetailNotificationDto {
    return true;
}

export function IActivityDetailNotificationDtoFromJSON(json: any): IActivityDetailNotificationDto {
    return IActivityDetailNotificationDtoFromJSONTyped(json, false);
}

export function IActivityDetailNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IActivityDetailNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'approval_code': json['approval_code'] == null ? undefined : json['approval_code'],
        'approval_codes': json['approval_codes'] == null ? undefined : json['approval_codes'],
        'invoice_posting_id': json['invoice_posting_id'] == null ? undefined : json['invoice_posting_id'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'custom_denial_reason': json['custom_denial_reason'] == null ? undefined : json['custom_denial_reason'],
    };
}

export function IActivityDetailNotificationDtoToJSON(json: any): IActivityDetailNotificationDto {
    return IActivityDetailNotificationDtoToJSONTyped(json, false);
}

export function IActivityDetailNotificationDtoToJSONTyped(value?: IActivityDetailNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'approval_code': value['approval_code'],
        'approval_codes': value['approval_codes'],
        'invoice_posting_id': value['invoice_posting_id'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'custom_denial_reason': value['custom_denial_reason'],
    };
}

